<template>
    <div class="conten">
		<div class="nTop" id="toTop" style="background-color:#FFF;">
		  <div class="wrapper clearfix">
		    <a class="logo">
		      <img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司" />
		      <h1>佰吉宏安国际能源有限公司</h1>
		    </a>
		    <a class="nt-link" @click="yanzheng('/main')">
		      <img src="../../assets/images/ico01.png" />
		      <span>个人中心</span>
		    </a>
		  </div>
		</div>
		
		<div class="header">
		  <div class="wrapper clearfix">
		    <div class="nav clearfix">
		      <!-- <router-link  to="/about">关于我们</router-link> -->
		      <a @click="tabIndex(1, '/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
		      <a @click="tabIndex(2, '/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
		      <a @click="tabIndex(3, '/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
		      <a @click="tabIndex(6, '/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
		    </div>
		    <div class="dl-an clearfix" v-if="isLogin">
		      <a @click="toPage('/login')">
		        <img src="../../assets/images/ico02.png" />
		        <span>登录</span>
		      </a>
		      <a @click="toPage('/register')">
		        <img src="../../assets/images/ico03.png" />
		        <span>注册</span>
		      </a>
		    </div>
		  </div>
		</div>
		
		
		
		<div class="top_box">
			<div class="top">
				<div class="top_left">
					个人中心
				</div>
				<div class="top_right">
					您当前所在位置：<a><router-link  to="/home">首页</router-link></a> > <span>个人中心</span>
				</div>
			</div>
		</div>
		<div class="center_box">
			<div class="center_left">
				<div class="left_first">
					个人中心
				</div>
				<div class="left_item" @click="openPage('main')">
					<img src="../../assets/icon/m_icon1.png">
					基本信息
				</div>
				<a>
				<div class="left_item" @click="openPage('main_money')">
					<img src="../../assets/icon/m_icon2.png">
					保证金余额
				</div>
				</a>
				<a>
				<div class="left_item" :style="active"  @click="openPage('main_record')">
					<img style="height: 20px ;" src="../../assets/icon/m_icon3.png">
					竞拍记录
				</div>
				</a>
				<a>
				<div class="left_item" @click="openPage('main_news')">
					<img  style="height: 20px ;" src="../../assets/icon/m_icon4.png">
					消息提醒
					<div class="red" v-if="isRed"></div>
				</div>
				</a>
				<a>
				<div class="left_item" @click="quit">
					<img src="../../assets/icon/m_icon5.png">
					退出登录
				</div>
				</a>
			</div>
			<div class="center_right">
				<div class="center_right_top">
					<div class="line"></div>
					竞拍记录
				</div>
				<div class="center_right_bottom">
					<div class="center_right_tab">
						<div class="tab_item" :class="index == 1 ?'active' : ''" @click="tabIndex1(1)">
							竞拍成功		
						</div>
						<div class="tab_item"  :class="index == 2 ?'active' : ''" @click="tabIndex1(2)">
							竞拍失败		
						</div>
					</div>
					<div class="center_right_list">
						<div class="list_title">
							<div class="" style="flex: 2;">
								招标
							</div>
							<div class="" style="flex: 1;">
								数量（吨）
							</div>
							<div class="" style="flex: 1;">
								单价（元）
							</div>
							<div class="" style="flex: 1;">
								保证金（元）
							</div>
							<div class="" style="flex: 1;">
								尾款
							</div>
							<div class="" style="flex: 1;">
								总金额（元）
							</div>
						</div>
						<div class="list_box">
							<div class="list_item" v-for="(item,index) in list" :key="index">
								<div class="list_items" style="flex: 2;">
									{{item.product_name}}
								</div>
								<div class="list_items" style="flex: 1;">
									{{item.numbers}}
								</div>
								<div class="list_items" style="flex: 1;">
									{{item.price}}
								</div>
								<div class="list_items" style="flex: 1;">
									{{item.bond_money}}
								</div>
								<div class="list_items" style="flex: 1;">
									{{item.payment_money}}
								</div>
								<div class="list_items" style="flex: 1;">
									{{item.total}}
								</div>
							</div>
						</div>
					</div>
					<div class="elPage">
					 <el-pagination
					   background
					   :page-size="6"
					   @current-change="change"
					   @prev-click="prev()"
					   @next-click="next()"
					   layout="prev, pager, next"
					   :total="this.count">
					 </el-pagination>
					</div>
				</div>
			</div>
		</div>
		
		
		<div class="footer">
		  <div class="wrapper">
		    <div class="f-nav">
		      <a @click="tabIndex(1, '/home')">首页</a>
		      <a @click="tabIndex(2, '/about')">关于我们</a>
		      <a @click="tabIndex(3, '/honor')">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')">招标信息</a>
		      <a @click="tabIndex(6, '/partner')">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')">联系我们</a>
		    </div>
		
		    <div class="f-box flexbox">
		      <img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot" />
		      <div class="f-center flexbox33 flexwarp" style="text-align: left;">
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico05.png" />
		          <p>联系电话：{{ footerMassage.mobile }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico06.png" />
		          <p>邮政编码：{{ footerMassage.postal }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico07.png" />
		          <p>访问量：{{ footerMassage.pageviews }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico08.png" />
		          <p>电子邮箱：{{ footerMassage.email }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico09.png" />
		          <p>公司地址：{{ footerMassage.address }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico10.png" />
		          <p>交易量：{{ footerMassage.trading_volume }}</p>
		        </div>
		      </div>
		      <div class="qrcode">
		        <img :src="footerMassage.image_id5_url" alt="" />
		        <p>扫一扫了解更多</p>
		      </div>
		    </div>
		    <div class="copyright">
		      Copyright 2021 ·版权所有 佰吉宏安国际能源有限公司
		      <a href="https://beian.miit.gov.cn" target="_blank">{{ footerMassage.site_icp }}&nbsp;{{ footerMassage.site_wabah }}</a>
		      <br />
		      建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
		    </div>
		  </div>
		</div>
    </div>
</template>

<script>
	import Utils from '../../utils/utils.js';
export default {
    name: 'main_news',
    data() {
        return {
			list:[],
			page:1,
			count:0,
		   active:'background-color: #e6e6e6;',
		     isRed:false,
			index:1,
			
			
			
			keyIndex:0,
			isLogin: true,
			footerMassage:'',
		};
    },
  mounted() {
      this.getList()
	  this.getRed()
	  
	  
	  this.site_info()
  },
  methods: {
	  tabIndex(index,str){
	  	// this.keyIndex = index
	  	// window.sessionStorage.setItem('keyIndex', index);
	  	// this.$setStorage('lastKeyIndex',index)
	  	// this.$setStorage('keyIndex',index)
	  	
	  	this.$router.push({
	  		path: str
	  	});
	  },
	  tabIndex1(index){
	  	if(index == this.index) return
	  	this.index = index
		this.page = 1
		this.getList()
	  },
	  async getRed() {
	  		  var _this = this
	      let { status, message, data } = await this.$ajax('no_read_information', {
	  			userToken: this.$getStorage('userToken'),
	      });
	      if (status == this.SUCCESS_CODE) {
			    Utils.$emit('getRed','msg');
	  			if(data == 0){
	  				_this.isRed = false
	  			}else{
	  				_this.isRed = true
	  			}
	      } else {
	          this.$message(message);
	      }
	  },
	  openPage(str){
	  	this.$router.push({
	  		path: str,
	  		// query: {  }
	  	});
	  },
	  	
	  quit() {
	  	this.$confirm('您确定退出吗?', '提示', {
	  	  confirmButtonText: '确定',
	  	  cancelButtonText: '取消',
	  	  type: 'warning'
	  	}).then(() => {
	  	  this.$message({
	  		type: 'success',
	  		message: '退出成功!'
	  	  });
	  	  window.sessionStorage.clear()
	  	  this.$router.push({
	  	      path: "/home"
	  	  });
		  window.location.reload();
	  	}).catch(() => {
	  	          
	  	});
	    },
  	change(e){
  		this.page = e
  		this.getList()
  	},
  	prev(e){
  		this.page = this.page - 1
  		this.getList()
  	},
  	next(e){
  		this.page = this.page + 1
  		this.getList()
  	},
      async getList() {
          let { status, message, data } = await this.$ajax('bidding_results', {
  			page:this.page,
  			limit:6,
			userToken: this.$getStorage('userToken'),
			type:this.index
          });
          if (status == this.SUCCESS_CODE) {
  			this.count = data.count
  			this.list = data.list
          } else {
              this.$message(message);
          }
      },
   //底部导航信息
   async site_info(idnex) {
     this.timeIndex = idnex;
     if (this.$getStorage('userToken')) {
       this.isLogin = false;
     } else {
       this.isLogin = true;
     }
     let { status, message, data } = await this.$ajax('site_info', {});
     if (status == this.SUCCESS_CODE) {
       this.footerMassage = data;
     } else {
       this.$message(message);
     }
   },
   yanzheng(str) {
     var _this = this;
     if (this.$getStorage('userToken')) {
       _this.toPage(str);
     } else {
       _this.$message({
         message: '请先登录',
         type: 'warning'
       });
       _this.toPage('/login');
     }
   },
   toPage(pathName, title) {
     this.$router.push({
       path: pathName,
       query: { pageTitle: title }
     });
   },
 
  }
};
</script>

<style scoped>
	/* .center_left a:hover{
		background-color: #F5F5F5;
	} */
	.conten{
		background-color: #F5F5F5;
	}
	.top_box{
		width: 100%;
		height:55px;
		background-color: #fff;
		display: flex;
		align-items: center;
	}
	.top{
		width:1320px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
	}
	.top_left{
		font-size: 19px;
		font-weight: bold;
		margin-left: 10px;
	}
	.left_first{
		padding: 12px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		background-color: #8a0d02;
	}
	.red{
		position: absolute;
		background-color: #ff1400;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		right: 38px;
		top: 12px;
		z-index: 80;
	}
	.left_item{
		background-color: #fff;
		padding: 14px 25px;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: bold;
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	.left_item img{
		width: 18px;
		height: 18px;
		display: block;
		margin-right: 10px;
	}
	.top_right{
		font-size: 10px;
		display: flex;
		align-items: center;
		color:#666666;
		margin-right: 10px;
	}
	.top_right a{
		margin-right:5px;
	}
	.top_right span{
		margin-left: 5px;
		font-weight: 600;
		color: #000 !important;
	}
	.center_box{
		width: 1300px;
		display: flex;
		justify-content: space-between;
		margin: 20px auto;
	}
	.center_left{
		background-color: #fff;
		width:150px;
		margin-right: 10px;
		padding-bottom: 200px;
	}
	.center_right{
		flex: 1;
	}
	.center_right_top{
		display: flex;
		align-items: center;
		padding: 12px;
		background-color: #fff;
		margin-bottom: 10px;
		font-size: 12px;
		font-weight: bold;
	}
	.center_right_top div{
		width: 3px;
		height: 14px;
		background-color: #8a0d02;
		margin-right: 8px;
	}
	.center_right_bottom{
		min-height: 500px;
		padding: 20px;
		background-color: #fff;
	}
	.center_right_tab{
		width: 100%;
		border-bottom: 1px solid #f3f3f3;
		height: 35px;
		display: flex;
		margin-bottom: 30px;
	}
	.left_item:hover{
		background-color: #F5F5F5 !important; 
	}
	.tab_item{
		line-height: 35px;
		height: 100%;
		width: 130px;
		text-align: center;
		font-size: 10px;
	}
	.active{
		font-size: 13px;
		background-color: #b69862 !important;
		color: #fff !important;
		font-weight: bold !important;
	}
.center_right_list{
		flex: 1;
		display: flex;
		flex-direction: column;
		width: 100%;
		background-color: #fff;
		min-height: 400px;
	}
	.list_title{
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #f5f5f5;
		padding: 10px 0px;
		font-size: 14px;
	}
	.list_box{
		/* height: 300px; */
	}
	.list_item{
		width: 100%;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #e5e5e5;
		height: 60px;
	}
	.list_items{
		text-align: center;
	}
	.elPage{
		width: 100%;
		margin-top: 20px;
	} 

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #8a0d02 ;
	} 
	 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover{
		color: #8a0d02;
	}
	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
		color: #fff ;
	} 
</style>



// WEBPACK FOOTER //
// src/views/main/main_record.vue